import { FunctionComponent, useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import ArrowInCircle from '@/components/atom/icon/Arrow/ArrowInCircle';
import { DIRECTION } from '@/types/common';

/**
 * @description Move Scroll To Top
 * @defaultvalue minY 3000
 */

interface Props {
  minY?: number;
}
const ScrollTopStickyButton: FunctionComponent<Props> = ({ minY }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [lastScrollY, setLastScrollY] = useState<number>(0);
  const [innerHeight, setInnerHeight] = useState<number>(0);

  const onScroll = () => {
    const scrollY = window.scrollY;
    if (window.scrollY <= innerHeight) {
      return setIsVisible(false);
    }
    scrollY > lastScrollY ? setIsVisible(false) : setIsVisible(true);
    setLastScrollY(scrollY);
  };

  const onScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  useLayoutEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  });

  useEffect(() => {
    if (!minY) {
      setInnerHeight(window.innerHeight * 2);
    }
  }, [minY]);
  return (
    <ScrollTopStickyButtonContainer isVisible={isVisible}>
      <ScrollTopStickyButtonWrapper onClick={onScrollTop}>
        상단으로 가기 <ArrowInCircle direction={DIRECTION.TOP} />
      </ScrollTopStickyButtonWrapper>
    </ScrollTopStickyButtonContainer>
  );
};

export default ScrollTopStickyButton;

const ScrollTopStickyButtonContainer = styled.div<{
  isVisible: boolean;
}>`
  position: fixed;
  margin: 0 auto;
  left: 50%;
  visibility: ${({ isVisible }) => !isVisible && 'hidden'};
  opacity: ${({ isVisible }) => !isVisible && 0};
  transform: translate(-50%, -50%);
  top: calc(${({ theme }) => theme.size.appHeader.height} + 28px);
  transition: all 0.5s ease-out;
`;

const ScrollTopStickyButtonWrapper = styled(DefaultButtonStyled)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 156px;
  height: 32px;
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);

  ${({ theme }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.white};
    background: ${theme.color.gray800};
  `}

  svg {
    margin-left: 8px;
  }

  &:active {
    background: ${({ theme }) => theme.color.gray700};
  }
`;
